// extracted by mini-css-extract-plugin
export default {"tabs":"HistoryTab_tabs__5kptx","tab":"HistoryTab_tab__lkGew","tabDesc":"HistoryTab_tabDesc__Hr7NP"};